import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.createQuestionnaires.loading;
export const questionnariesErrorMessage = (state: RootState) =>
  state.createQuestionnaires.error;
export const createQuestionnairesDataResponse = (state: RootState) =>
  state.createQuestionnaires.createQuestionnairesResponse;
